var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && Object.keys(_vm.item).length > 0)?_c('div',{staticClass:"barcode-label",class:[
    'text-' + _vm.textAlign,
    _vm.fontOptions.includes('bold') ? 'barcode-bold' : '',
    _vm.fontOptions.includes('italic') ? 'barcode-italic' : '',
  ],style:({
    fontFamily: 'var(--app-font)',
    padding: `${_vm.marginTop}px ${_vm.marginLeft}px ${_vm.marginBottom}px ${_vm.marginRight}px`,
    backgroundColor: _vm.background,
  })},[(_vm.customPrefix)?_c('div',{staticClass:"font barcode-text",style:({
      fontSize: _vm.fontSize + 'px',
      marginBottom: _vm.textMargin + 'px',
    })},[_vm._v(" "+_vm._s(_vm.customPrefix)+" ")]):_vm._e(),(_vm.showName)?_c('div',{staticClass:"font barcode-text",style:({
      fontSize: _vm.fontSize + 'px',
      marginBottom: _vm.textMargin + 'px',
    })},[_vm._v(" "+_vm._s(_vm.item.name)+" "),(_vm.showSize && _vm.item.size)?_c('span',[_vm._v(" - "+_vm._s(_vm.item.size.name))]):_vm._e()]):_vm._e(),(_vm.showPrice)?_c('div',{staticClass:"font barcode-text",style:({
      fontSize: _vm.fontSize + 'px',
      marginBottom: _vm.textMargin + 'px',
    })},[_vm._v(" "+_vm._s(_vm.moneyFormatPrint(_vm.item.price_sale))+" ")]):_vm._e(),(_vm.showCode)?_c('div',{staticClass:"font barcode-text",style:({
      fontSize: _vm.fontSize + 'px',
      marginBottom: _vm.textMargin + 'px',
    })},[_vm._v(" "+_vm._s(_vm.item.code)+" ")]):_vm._e(),_c('barcode',{staticClass:"barcode-svg",attrs:{"value":_vm.item.code,"width":_vm.width,"height":_vm.height,"fontSize":_vm.fontSize,"fontOptions":_vm.fontOptions,"textAlign":_vm.textAlign,"textMargin":_vm.textMargin,"displayValue":_vm.displayValue,"lineColor":_vm.lineColor,"background":_vm.background,"marginTop":_vm.marginTop,"marginBottom":_vm.marginBottom,"marginLeft":_vm.marginLeft,"marginRight":_vm.marginRight,"format":_vm.format}}),(_vm.customSuffix)?_c('div',{staticClass:"font barcode-text",style:({
      fontSize: _vm.fontSize + 'px',
      marginTop: _vm.textMargin + 'px',
    })},[_vm._v(" "+_vm._s(_vm.customSuffix)+" ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }